import {Injectable} from "@angular/core";
import {
    CacheService,
    LanguageService,
    PaginationService,
    SimpleEntityService,
    TranslatedString
} from "@customcoding/shared";
import {HttpClient} from "@angular/common/http";
import {Event, EventCreateRequest, EventUpdateRequest} from "../shared/models/event.model";
import {BehaviorSubject, firstValueFrom, Observable} from "rxjs";
import moment from 'moment';
import {TabConfig} from "./event-list/event-list.component";
import {CalendarEventPhase} from "../shared/models/calendarEvent.model";

@Injectable({
	providedIn: 'root'
})
export class EventService extends SimpleEntityService<Event, EventCreateRequest, EventUpdateRequest> {

    //we could move this inside the EnityService + List Component as well (Shared package
    private additionalTabs$ = new BehaviorSubject<TabConfig[]>([]);

    constructor(
		http: HttpClient,
		pagination: PaginationService,
		private languageService: LanguageService,
        private cache: CacheService
	) {
		super(http, pagination, '/api/ticket-module/event')
	}

    sendEmail(subject: TranslatedString, content: TranslatedString, eventId: number) {
        const body = {subject: subject, content: content}
        return this.http.post(this.apiEndpoint + '/' + eventId + '/send-email', body)
    }

	exportCSV(event: Event) {

		if (!event) return;

		firstValueFrom(
			this.http.get('/api/golden-me/dashboard/event/' + event?.id + '/csv', {responseType: 'blob'})
		).then(blob => {
			const a = document.createElement('a');
			const objectUrl = URL.createObjectURL(blob);
			a.href = objectUrl;
			a.download = this.languageService.chooseTranslation(event.name) + ' ' + moment(event.date).format('DD-MM-YYYY') + ' export date ' + moment().format('DD-MM-YYYY HH mm') + '.csv';
			a.click();
			URL.revokeObjectURL(objectUrl);
		})
	}

    exportCSVTemplate() {
        const fileUrl = 'assets/media/files/template.csv';
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = 'template.csv';
        link.click();
    }

	copyEvent(id: number) {
        return this.http.post(this.apiEndpoint +`/${id}/copy`, {});
	}

    registerTabs(tabs: TabConfig[]) {
        console.log("registerTabs,tabs: ", tabs);
        this.additionalTabs$.next([...this.additionalTabs$.value, ...tabs])
        console.log("registerTabs,this.additionalTabs$.value: ", this.additionalTabs$.value);
    }

    getAdditionalTabs(): Observable<TabConfig[]> {
        return this.additionalTabs$.asObservable();
    }

    clearTabs() {
        this.additionalTabs$.next([]);
    }

    getEventPhases() {
        return this.http.get<CalendarEventPhase[]>('/api/ticket-module/events/phases/calendar');
    }

    cancelEvent(eventId: number) {
        return this.http.post(this.apiEndpoint + '/' + eventId + '/cancel', {_method: 'PATCH'});
    }

    cancelPhases(eventId: number, phaseIds: number[]) {
        const body = {_method: 'PATCH', phases: phaseIds}
        return this.http.post(this.apiEndpoint + '/' + eventId + '/phases/cancel', body);
    }

    getCached(id: number): Observable<Event> {
        return this.cache.get(`/api/ticket-module/event/${id}`) as Observable<Event>;
    }

    allCached(): Observable<Event[]> {
        return this.cache.get(`/api/ticket-module/event?isPaginated=0`) as Observable<Event[]>;
    }

}
